module.exports = __webpack_public_path__ + "static/diy_recipe_mug_cakes-52efb5bce665cb9bf21d72251ba64825.pdf";